import { parseServerPresetId, resolveServerPresetKey, type ServerPresetKeyParsers } from './serverPresetKey';

/** Имя, под которым пользовательские дашборды хранятся на сервере среди системных и совместных пресетов */
export const DASHBOARD_PRESETS_TABLE_NAME = 'dashboardPresets';

/**
 * Начало ключа совместного дашборда: `shared:<id записи сервера>`. Личные дашборды ключуются
 * uuid, поэтому с ключом совместного не совпадают. Под этим ключом совместный дашборд лежит
 * и в настройках пользователя (`activePresetId`, `sharedFilters`).
 */
const SHARED_DASHBOARD_PRESET_PREFIX = 'shared:';

/**
 * Начало ключа системного дашборда: `system:<id записи сервера>`. Записи системных и совместных
 * пресетов на сервере нумеруются каждая своим счётом, поэтому ключи различаются началом. Под этим
 * ключом системный дашборд лежит и в настройках пользователя (`activePresetId`, `sharedFilters`).
 */
const SYSTEM_DASHBOARD_PRESET_PREFIX = 'system:';

/** Собирает ключ совместного дашборда по идентификатору его записи на сервере. */
export const buildSharedDashboardPresetId = (serverId: number): string =>
  `${SHARED_DASHBOARD_PRESET_PREFIX}${serverId}`;

/**
 * Возвращает идентификатор серверной записи совместного дашборда либо `null`, если ключ
 * принадлежит личному или системному дашборду.
 */
export const parseSharedDashboardPresetId = (presetId: string): number | null =>
  parseServerPresetId(presetId, SHARED_DASHBOARD_PRESET_PREFIX);

/** Собирает ключ системного дашборда по идентификатору его записи на сервере. */
export const buildSystemDashboardPresetId = (serverId: number): string =>
  `${SYSTEM_DASHBOARD_PRESET_PREFIX}${serverId}`;

/**
 * Возвращает идентификатор серверной записи системного дашборда либо `null`, если ключ
 * принадлежит личному или совместному дашборду.
 */
export const parseSystemDashboardPresetId = (presetId: string): number | null =>
  parseServerPresetId(presetId, SYSTEM_DASHBOARD_PRESET_PREFIX);

/** Разбор ключей серверных дашбордов — системного и совместного. */
export const DASHBOARD_PRESET_KEY_PARSERS: ServerPresetKeyParsers = {
  parseSystemId: parseSystemDashboardPresetId,
  parseSharedId: parseSharedDashboardPresetId,
};

/**
 * Ключ принадлежит серверному дашборду — системному или совместному. Такой дашборд в настройках
 * пользователя не хранится: есть ли он, известно только по списку с сервера.
 */
export const isServerDashboardPresetId = (presetId: string): boolean =>
  resolveServerPresetKey(presetId, DASHBOARD_PRESET_KEY_PARSERS) !== null;
